import { useEffect, useState } from 'react';
import { apiFetch } from './apiFetch';
import { getToken } from './PasswordGate';

export interface FamilyMember {
  id: number;
  email: string;
  displayName: string | null;
  pictureUrl: string | null;
  lastSeenAt: string;
}

export type FamilyState =
  | { status: 'loading'; members: [] }
  | { status: 'ready'; members: FamilyMember[] }
  | { status: 'error'; members: []; error: string };

export function useFamily(): FamilyState {
  const [state, setState] = useState<FamilyState>({ status: 'loading', members: [] });

  useEffect(() => {
    let cancelled = false;
    const token = getToken();
    if (!token) {
      setState({ status: 'ready', members: [] });
      return;
    }
    apiFetch('/api/family')
      .then(async (res) => {
        if (!res.ok) throw new Error(`family ${res.status}`);
        return (await res.json()) as { members: FamilyMember[] };
      })
      .then((data) => {
        if (cancelled) return;
        setState({ status: 'ready', members: data.members });
      })
      .catch((err: Error) => {
        if (cancelled) return;
        setState({ status: 'error', members: [], error: err.message });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
